import CampaignPage from './campaign.container'

export default CampaignPage;